// Momentum's connection chime. Prime during the submit gesture so delayed
// avatar readiness can play it on browsers that suspend new audio contexts.
let context: AudioContext | null = null;

export function primeConnectionSound(): void {
  try {
    const Audio = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    context ??= new Audio();
    if (context.state === 'suspended') void context.resume().catch(() => {});
  } catch { /* Sound must never block connecting. */ }
}

export function playConnectionSound(): void {
  const ctx = context;
  if (!ctx || ctx.state !== 'running') return;
  const now = ctx.currentTime;
  const volume = 0.7;
  function tone(frequency: number, type: OscillatorType, start: number, peak: number, attack: number, decay: number): void {
    const osc = ctx!.createOscillator();
    const gain = ctx!.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, now + start);
    gain.gain.setValueAtTime(0, now + start);
    gain.gain.linearRampToValueAtTime(peak * volume, now + start + attack);
    gain.gain.exponentialRampToValueAtTime(0.001, now + start + decay);
    osc.connect(gain);
    gain.connect(ctx!.destination);
    osc.onended = () => { osc.disconnect(); gain.disconnect(); };
    osc.start(now + start);
    osc.stop(now + start + decay);
  }
  try {
    [1046.5, 1318.5, 1568, 2093].forEach((frequency, i) => tone(frequency, 'sine', 0.12 * i, 0.06 * (1 - 0.15 * i), 0.02, 0.8));
    tone(4186, 'triangle', 0.3, 0.02, 0.05, 0.9);
    tone(523.25, 'sine', 0, 0.04, 0.05, 1);
  } catch { /* Sound must never block the first response. */ }
}
